module.exports = __webpack_public_path__ + "static/media/JPBA01.8c2cef68.jpg";